import baseStyled, { css as baseCss, ThemeContext, } from "styled-components";
import { useContext } from "react";
export const useTheme = () => useContext(ThemeContext);
export const styled = baseStyled;
export const css = baseCss;
//# sourceMappingURL=styled.js.map